import { Injectable } from '@angular/core';
import { WebSdkService } from '../web-sdk/web-sdk.service';
import { AppSelectorService } from '../app-selector/app-selector.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureSupportService {
  private companyFeatureList: any;
  private companyDetails: any;
  private loading = true;

  constructor(
    private webSdkService: WebSdkService,
    private appSelectorService: AppSelectorService) {
      this.setupSDK();
    }

  /**
   * setup feature enabling
   */
  private setupSDK() {
    this.webSdkService.getData('JSON', 'company-feature-list', {}).then((sdkData: any) => {
      this.companyFeatureList = sdkData;
      this.companyDetails = this.appSelectorService.getCompanyDetails();
    }).finally(() => {
      this.loading = false;
      this.checkfeatureList('segments');
    });
  }

  public checkfeatureList(feature: string) {
    const promise = new Promise<any>((resolve) => {
      this.webSdkService.getData('JSON', 'company-feature-list', {}).then((sdkData: any) => {
        this.companyFeatureList = sdkData;
        this.companyDetails = this.appSelectorService.getCompanyDetails();

        if (this.companyDetails.id && this.companyDetails.id in this.companyFeatureList) {
          if (!this.companyFeatureList[this.companyDetails.id].includes(feature)) {
            resolve(false);
          }
        }
        resolve(true);
      });
    });

    return promise;
  }
}
